import {EnvConfig} from './envConfig.interface';
import {getConfiguration} from './dotEnvConfiguration';

const configuration = getConfiguration();

const productionConfigBase: Omit<EnvConfig, 'host' | 'defaultBpVariant'> = {
  production: true,
  embedHostingBaseUrl: configuration.HOSTING_BASE_URL,
  accountManagementUrl: 'https://account.simpleclub.com',
  apiBaseUrl: configuration.API_BASE_URL,
  language: 'de',
  languageArea: {
    firestoreId: 'de',
    tag: 'de_DE',
    countryCode: 'DE',
  },
  firebaseConfig: {
    apiKey: configuration.FIREBASE_API_KEY,
    authDomain: configuration.FIREBASE_AUTH_DOMAIN,
    databaseURL: configuration.FIREBASE_DATABASE_URL,
    projectId: configuration.FIREBASE_PROJECT_ID,
    storageBucket: configuration.FIREBASE_STORAGE_BUCKET,
    messagingSenderId: configuration.FIREBASE_MESSAGING_SENDER_ID,
    appId: configuration.FIREBASE_APP_ID,
    measurementId: configuration.FIREBASE_MEASUREMENT_ID,
  },
  adyen: {
    clientKey: 'live_DARNDZDGIZEQ7ADIAA2HS24DIURU3O7I',
    embed: {
      css: {
        url: 'https://checkoutshopper-live.cdn.adyen.com/checkoutshopper/sdk/6.9.0/adyen.css',
        integrity:
          'sha384-Qy8fmdXhmf9H2Pgbmr7b0UkpeSvi7n3RFhpoZXYQPGpKIn9SH+0fT4905fsSA8Am',
        crossOrigin: 'anonymous',
      },
    },
  },
  gtmContainerId: 'GTM-PPLZJ6L',
};

export const productionConfig: EnvConfig[] = [
  {
    ...productionConfigBase,
    host: 'get.simpleclub.com',
    defaultBpVariant: 'payStripeTest',
  },
  {
    ...productionConfigBase,
    host: 'simpleclub.com',
    defaultBpVariant: 'pay1k4oo9b4',
  },
  {
    ...productionConfigBase,
    host: 'simpleclub.de',
    defaultBpVariant: 'payStripeTest',
  },
  {
    ...productionConfigBase,
    host: 'www.simpleclub.de',
    defaultBpVariant: 'payStripeTest',
  },
];
